import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
// import * as Sentry from "@sentry/react";

import theme from "./theme.tsx";
import { BrowserRouter } from "react-router-dom";
import ErrorBoundary from "@/libs/ErrorBoundary.tsx";

// Sentry initialization
// Sentry.init({
//   dsn: import.meta.env.VITE_SENTRY_DNS,
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration(),
//   ],
//   tracesSampleRate: 1.0,
//   tracePropagationTargets: [
//     "localhost",
//     new RegExp(`^${`${import.meta.env.VITE_APP_URL}`.replace(/\./g, "\\.")}`),
//   ],
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
//   environment: import.meta.env.MODE,
//   enabled: !import.meta.env.DEV,
// });

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
);
